import React, { useState, useEffect } from "react";
import Plan from "../common/plan";
import api from "../common/api";
import { formatBytes, changeModal } from "../common/utils";
import toast from "react-hot-toast";
import ModalConfirm from "../common/modalConfirm";

function PlanPage() {
  const [order, setOrder] = useState(true);
  const [planInfo, setplanInfo] = useState({});
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedCount, setSelectedCount] = useState(1); // 订购数量
  const [billingCycle, setBillingCycle] = useState("monthly"); // 计费周期
  const [selectedPrice, setSelectedPrice] = useState(0); // 选中的套餐价格
  const [isLoading, setIsLoading] = useState(true);

  const getplanInfo = async () => {
    setIsLoading(true);
    toast
      .promise(api("get", "/api/user/plan", null), {
        loading: "加载中...",
        success: "套餐列表加载成功",
        error: "加载失败，请稍后重试",
      })
      .then((response) => {
        if (response.message === "401") {
          localStorage.removeItem("token");
          localStorage.removeItem("expire");
          localStorage.removeItem("username");
          window.location.href = "/login";
        } else {
          setplanInfo(response.data);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleSelectPlan = (planId, days, price) => {
    setSelectedPlan(planId);
    // 低价套餐只允许年付
    if (price <= 5 && days === 30) {
      setSelectedCount(12);
      setBillingCycle("yearly");
    } else {
      setSelectedCount(1); // 将 count 设置为 1
      setBillingCycle("monthly");
    }
    setSelectedPrice(price);
    changeModal("orderPlan", true);
  };

  const handleBillingCycleChange = (event) => {
    const cycle = event.target.value;
    setBillingCycle(cycle);
    setSelectedCount(cycle === "yearly" ? 12 : 1);
  };

  const handleConfirmSelectPlan = async () => {
    if (order) {
      setOrder(false);
      toast.promise(
        api("post", "/api/user/plan", {
          planId: selectedPlan,
          count: selectedCount,
        }),
        {
          loading: "正在订购计划...",
          success: (response) => {
            if (response.status) {
              // 删除本地userInfo缓存
              localStorage.removeItem("userInfo");
              setTimeout(() => {
                window.location.href = "/dashboard?do=sub";
              }, 1500);
              return "订购成功";
            } else {
              setOrder(true);
              if (response.message === "余额不足") {
                setTimeout(() => {
                  window.location.href = "/dashboard?do=charge";
                }, 1500);
              }
              throw new Error(response.message);
            }
          },
          error: (error) => {
            setOrder(true);
            return error.message;
          },
        }
      );
    } else {
      toast.error("点击过快");
    }
    changeModal("orderPlan", false);
  };

  useEffect(() => {
    getplanInfo();
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <section className="mb-12">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              选购套餐
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              选择适合您的套餐，点击订购即可购买，购买后会替换现有套餐。
            </p>
            <p className="text-sm text-gray-500 mt-2">
              如此页面无法操作可前往{" "}
              <a className="text-blue-600 hover:text-blue-700 transition-colors duration-300" href="/old">
                兼容操作页面
              </a>{" "}
              进行操作
            </p>
          </div>

          {isLoading ? (
            <div className="max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none animate-pulse">
              {[...Array(3)].map((_, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-lg p-6">
                  <div className="h-8 w-32 bg-gray-200 rounded mb-4"></div>
                  <div className="h-12 w-24 bg-gray-200 rounded mb-6"></div>
                  <div className="space-y-3">
                    {[...Array(6)].map((_, i) => (
                      <div key={i} className="flex items-center space-x-3">
                        <div className="h-4 w-4 bg-gray-200 rounded"></div>
                        <div className="h-4 w-48 bg-gray-200 rounded"></div>
                      </div>
                    ))}
                  </div>
                  <div className="h-10 w-full bg-gray-200 rounded-full mt-6"></div>
                </div>
              ))}
            </div>
          ) : (
            <div className="max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
              {planInfo.length > 0 &&
                planInfo.map((plan) => (
                  <Plan
                    key={plan.id}
                    title={plan.name}
                    price={`${plan.price}￥`}
                    onSelect={() =>
                      handleSelectPlan(plan.id, plan.days, plan.price)
                    }
                    group={plan.group}
                    features={[
                      `${plan.days === 0 ? "永不过期" : `${plan.days}天有效期`}`,
                      `${plan.limit === 0 ? "不限速" : `限速 ${plan.limit}Mbps`}`,
                      `${formatBytes(plan.traffic)}流量`,
                      `${plan.device === 0
                        ? "不限设备数"
                        : `限同时在线 ${plan.device}台 设备`
                      }`,
                      process.env.REACT_APP_NOIEPL === 'true'
                        ? "新疆可用"
                        : (plan.group === 0 ? "不支持专线" : "支持专线"),
                      `流媒体解锁 & GPT不降智`,
                    ]}
                  />
                ))}
            </div>
          )}
        </section>
      </div>
      <ModalConfirm
        target="orderPlan"
        title="确认订购"
        onConfirm={handleConfirmSelectPlan}
      >
        <div className="space-y-4">
          <p className="text-gray-600">您确认要订购这个套餐吗？这会替换您当前的套餐。</p>
          {selectedPlan &&
            planInfo.find((plan) => plan.id === selectedPlan)?.days === 30 && (
              <div className="bg-gray-50 rounded-xl p-4">
                <p className="text-gray-600 mb-2">年付为12个周期，每个周期30天</p>
                <p className="text-gray-600 mb-4">周期流量用完可以提前重置到下一周期</p>
                <div className="bg-white rounded-lg p-4 mb-4">
                  <p className="text-lg font-semibold text-gray-900">
                    支付金额:{" "}
                    {billingCycle === "yearly" ? (
                      <>
                        <span className="line-through text-gray-400">{selectedPrice * 12}￥</span>{" "}
                        <span className="text-red-600 font-bold">{selectedPrice * 10}￥</span>
                      </>
                    ) : (
                      <span className="text-gray-900">{selectedPrice}￥</span>
                    )}
                  </p>
                </div>
                <div className="flex justify-center space-x-6">
                  {selectedPrice > 5 && (
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="radio"
                        value="monthly"
                        checked={billingCycle === "monthly"}
                        onChange={handleBillingCycleChange}
                        className="form-radio h-5 w-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                      />
                      <span className="text-gray-700">月付</span>
                    </label>
                  )}
                  <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                      type="radio"
                      value="yearly"
                      checked={billingCycle === "yearly"}
                      onChange={handleBillingCycleChange}
                      className="form-radio h-5 w-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                    />
                    <span className="text-gray-700">年付</span>
                  </label>
                </div>
              </div>
            )}
        </div>
      </ModalConfirm>
    </main>
  );
}

export default PlanPage;
